import {DataTestAttrs} from '@benchling/js-test-utils';
import React, {ReactNode} from 'react';

import {prependAOrAn} from 'BenchlingUtil';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {capitalize} from 'util/NameUtil';

interface Props {
  dataTestAttrs?: DataTestAttrs;
  itemDescription: string;
  isPlural: boolean;
  nameTemplateAppliesToAllItems?: boolean; // Only has an effect when isPlural is true
  supportingInfo?: ReactNode;
}

export default function NameTemplateInfoBanner(props: Props): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      dataTestAttrs={props.dataTestAttrs}
      text={`${
        props.isPlural && !props.nameTemplateAppliesToAllItems
          ? `Some ${props.itemDescription}`
          : capitalize(props.itemDescription)
      } ${props.isPlural ? 'names' : 'name'} will be set using ${prependAOrAn(
        props.itemDescription
      )} name template.`}
      supportingInfo={props.supportingInfo}
    />
  );
}
